import { CircularProgress, Collapse, Grid, IconButton, InputLabel } from '@material-ui/core';
import { Backdrop, NotificationText, Select, TextInput } from '@room-match/shared-ui-components';

import { useEffect, useState } from 'react';
import {
  FlexContainer,
  Heading,
  MainCont,
  MoreButton,
  SaveButton,
  ThreeColumn,
  TwoColumn6Grid,
  useStyles,
} from './SizeCard.styles';

import Autocomplete from '@material-ui/lab/Autocomplete';
import age from 'data/Age.json';
import ethnicity from 'data/Ethnicities.json';
import Gender from 'data/Gender.json';
import metric from 'data/Metric.json';
import bustSize from 'data/new/BustSize.json';
import chestSize from 'data/new/ChestSize.json';
import glovesize from 'data/new/GloveSize.json';
import hatsize from 'data/new/HatSize.json';
import newheight from 'data/new/Height.json';
import inseam from 'data/new/Inseam.json';
import kidsShoes from 'data/new/KidsShoes.json';
import length from 'data/new/Length.json';
import minorBustSize from 'data/new/minorSizes/MinorBust.json';
import minorGlove from 'data/new/minorSizes/MinorGlove.json';
import minorHat from 'data/new/minorSizes/MinorHat.json';
import minorheight from 'data/new/minorSizes/MinorHeight.json';
import minorInseam from 'data/new/minorSizes/MinorInseam.json';
import minorWaist from 'data/new/minorSizes/MinorWaist.json';
import neck from 'data/new/NeckSize.json';
import maleShoeSize from 'data/new/ShoeSize.json';
import sleeves from 'data/new/SleeveSize.json';
import waist from 'data/new/Waist.json';
import newweight from 'data/new/Weight.json';
import Pronouns from 'data/Pronouns.json';
import region from 'data/Region.json';
import talentTypes from 'data/TalentTypes.json';
import unionList from 'data/Unions.json';
import { talentService } from 'shared/services/talentService';

import { matchSorter } from 'match-sorter';
import { useQueryClient } from 'react-query';
import useUnsavedChangesWarning from 'shared/hooks/useUnsaveChangesWarning';
import { IUnion } from 'shared/interfaces/IAccount';
import { useAppSelector } from 'shared/redux/store';
import { getErrorMessage } from 'shared/utils/room-shared';
import { usePersonalForm } from './PersonalForm';

const { updateTalent, getMyData, getGeneral, updateMe } = talentService();

import infants from 'data/new/Infants.json';
import kidClothing from 'data/new/KidsClothing.json';
import React from 'react';
import { COLORS } from 'shared/constants/COLORS';
import { CustomTypography } from 'shared/elements/CustomTypography';
import { IGeneralSection } from 'shared/interfaces/IGeneral';
import { ITalentUpdatePayload } from 'shared/interfaces/ITalent';
import { ls } from 'shared/utils/ls';
import CompCardButton from './CompCardButton';
import EthnicityDialog from './EthnicityDialog/EthnicityDialog';
import Babies from './Fields/Babies';
import Common from './Fields/Common';
import Female from './Fields/Female';
import Male from './Fields/Male';
import NonBinary from './Fields/NonBinary';
import GeneralOnSizeCard from './GeneralOnSizeCard';
import TalentTypesDialog from './TalentTypesDialog/TalentTypesDialog';
import { getRequiredFields, showNonRequiredFields } from './size_utils';
import NonRequired from './Fields/NonRequired';
import { BsChevronDoubleDown } from 'react-icons/bs';
interface Props {
  checkinSelfTapes?: boolean;
  onSave: VoidFunction;
  isOpportunities?: boolean;
  compCardAdd?: (val: { key: string; value: string }) => void;
  compCardRemove?: (arg: { key: string }) => void;
  disableButton?: boolean;
}

const SizeCard: React.FC<Props> = ({
  onSave,
  checkinSelfTapes,
  isOpportunities,
  compCardAdd,
  compCardRemove,
  disableButton,
}) => {
  const classes = useStyles();
  const { getLS } = ls();
  const user = JSON.parse(getLS('user') || '{}');
  const { mutateAsync: meUpdate, isLoading: isMeSaving } = updateMe();
  const { user: userState }: any = useAppSelector((state) => state);
  const { mutateAsync, isLoading: isUpdateLoading } = updateTalent();
  const [isLoading, setIsLoading] = useState(false);
  const [requiredOnly, setRequiredOnly] = useState<boolean>(true);
  const { data: generalData, isLoading: isGeneralLoading } = getGeneral(isOpportunities);
  const [collapsibles, setCollapsibles] = useState({
    unions: true,
    settings: !checkinSelfTapes,
  });
  const [generalInfo, setGeneralInfo] = useState<IGeneralSection>({
    ethnic_appearance_primary: '',
    ethnic_appearance_secondary: '',
    ethnic_appearance_other: '',
    hair_colour: '',
    eye_colour: '',
    hair_length: '',
    tattoo: [],
    piercings: [],
    facial_hair: [],
    physical_attributes: [],
    twin_triplet: [],
  });
  const [meInfo, setmeInfo] = useState<ITalentUpdatePayload>({
    gender: '',
    identifies_as: '',
  });
  const [birth, setBirth] = useState({
    day: '',
    month: '',
    year: '',
  });

  const [val, setVal] = useState<number[] | null>(null);

  const filterOptions: any = (options: any, { inputValue }: any) =>
    matchSorter(options, inputValue, {
      threshold: matchSorter.rankings.WORD_STARTS_WITH,
      baseSort: (a, b) => 0,
    });

  const [show, setShow] = useState<boolean>(false);
  const [unionToAdd, setUnionToAdd] = useState<IUnion>({
    name: '',
    id_number: '',
  });
  const { data: sizeCardData, isLoading: isSizeCardLocading } = getMyData(userState.user?.id || user.id);

  const sData = sizeCardData?.data?.talent;
  const queryClient = useQueryClient();
  const { routerPrompt, onDirty, onPristine } = useUnsavedChangesWarning(
    'You have unsave changes, this will be discarded on exit. Do you wish to continue?',
  );

  const handleSaveGeneralAppearance = async (sizes: ITalentUpdatePayload) => {
    const birth_date = `${birth.day}/${birth.month}/${birth.year}`;
    const mePayload = {
      ...meInfo,
      birth_date: (birth.day && birth.month && birth.year ? birth_date : null) as any,
      age_range_from: val ? val[0] : 0,
      age_range_to: val ? val[1] : 1,
    };
    const talentPayload = {
      ...sizes,
      general: {
        ...generalInfo,
      },
    };
    await meUpdate(
      {
        ...mePayload,
      },
      { onSuccess: () => queryClient.resetQueries(['me']) },
    );

    mutateAsync(
      {
        ...talentPayload,
      },
      {
        onSuccess: async () => {
          await queryClient.resetQueries(['talents/general']);
          setShow(true);
          onPristine();
          onSave();
        },
      },
    );
  };

  const { form } = usePersonalForm({
    data: sData,
    onSubmit: async (val) => {
      const modiefiedVal = { ...val };

      if (isOpportunities || compCardAdd) await handleSaveGeneralAppearance(modiefiedVal);
      else
        await mutateAsync(modiefiedVal, {
          onSuccess: () => {
            queryClient.invalidateQueries('my_data');
            queryClient.invalidateQueries(['talents/statistics'], {
              refetchInactive: true,
            });
            setShow(true);
            onPristine();
            onSave();
          },
        });

      setIsLoading(false);
    },
  });

  const union = form?.values?.unions?.[0];
  const isSagNumberRequired =
    checkinSelfTapes &&
    (union?.name?.toLowerCase() === 'sag/aftra' || union?.name?.toLowerCase() === 'financial core') &&
    !union?.id_number;

  const requiredFields = getRequiredFields(
    form.values.gender as any,
    form.values.adult_minor as any,
    form.values.country as any,
  );

  const nonRequiredFields = checkinSelfTapes
    ? showNonRequiredFields(form.values.gender as any, form.values.adult_minor as any, form.values.country as any)
    : [];

  const isMinor = form.values.adult_minor === 'minor';

  const [regionValue, setRegionValue] = useState('US');
  const [metricValue, setMetricValue] = useState(
    sData?.statistics && sData?.statistics ? sData?.statistics?.metric_system : 'AL',
  );

  const ethnicityOptions = ethnicity.map((i) => i);
  const talentTypesOptions = talentTypes.map((i) => i);

  // const heightOptions = (regionValue !== 'AU' ? USheight : newheight).map((i) =>
  const heightOptions = (isMinor ? minorheight.concat(newheight) : newheight).map((i) =>
    metricValue === 'AL' ? i.im : metricValue === 'CM' ? i.metric : i.imperial,
  );
  const filteredHeightOptions: any[] = [];
  heightOptions.forEach((e) => {
    if (!filteredHeightOptions.includes(e)) {
      filteredHeightOptions.push(e);
    }
  });

  const lengthOptions = length.map((i) => (metricValue === 'AL' ? i.im : metricValue === 'CM' ? i.metric : i.imperial));
  const filteredLengthOptions: any[] = [];
  lengthOptions.forEach((e) => {
    if (!filteredLengthOptions.includes(e)) {
      filteredLengthOptions.push(e);
    }
  });

  const waistOptions = (isMinor ? minorWaist.concat(waist) : waist).map((i) =>
    metricValue === 'AL' ? i.im : metricValue === 'CM' ? i.metric : i.imperial,
  );
  const filteredWaistOptions: any[] = [];
  waistOptions.forEach((e) => {
    if (!filteredWaistOptions.includes(e)) {
      filteredWaistOptions.push(e);
    }
  });

  const hatoptions = (isMinor ? minorHat.concat(hatsize) : hatsize).map((i) =>
    metricValue === 'AL' ? i.im : metricValue === 'CM' ? i.metric : i.imperial,
  );
  const filteredHatOptions: any[] = [];
  hatoptions.forEach((e) => {
    if (!filteredHatOptions.includes(e)) {
      filteredHatOptions.push(e);
    }
  });

  // const kidsLengthOptions = length.map((i) =>
  //   metricValue === 'AL' ? i.im : metricValue === 'CM' ? i.metric : i.imperial,
  // );
  // const filteredLengthOptions: any[] = [];
  // filteredLengthOptions.forEach((e) => {
  //   if (!filteredLengthOptions.includes(e)) {
  //     filteredLengthOptions.push(e);
  //   }
  // });

  const sleeveOption = sleeves.map((i) => (metricValue === 'AL' ? i.im : metricValue === 'CM' ? i.metric : i.imperial));
  const filteredSleeveOptions: any[] = [];
  sleeveOption.forEach((e) => {
    if (!filteredSleeveOptions.includes(e)) {
      filteredSleeveOptions.push(e);
    }
  });

  const gloveoptions = (isMinor ? minorGlove.concat(glovesize) : glovesize).map((i) =>
    metricValue === 'AL' ? i.im : metricValue === 'CM' ? i.metric : i.imperial,
  );
  const filteredGloveOptions: any[] = [];
  gloveoptions.forEach((e) => {
    if (!filteredGloveOptions.includes(e)) {
      filteredGloveOptions.push(e);
    }
  });

  const inseamOptions = (isMinor ? minorInseam.concat(inseam) : inseam).map((i) =>
    metricValue === 'AL' ? i.im : metricValue === 'CM' ? i.metric : i.imperial,
  );
  const filteredInseamOptions: any[] = [];
  inseamOptions.forEach((e) => {
    if (!filteredInseamOptions.includes(e)) {
      filteredInseamOptions.push(e);
    }
  });

  const chestOptions = chestSize.map((i) =>
    metricValue === 'AL' ? i.im : metricValue === 'CM' ? i.metric : i.imperial,
  );
  const filteredChestOptions: any[] = [];
  chestOptions.forEach((e) => {
    if (!filteredChestOptions.includes(e)) {
      filteredChestOptions.push(e);
    }
  });

  const neckOptions = neck.map((i) => (metricValue === 'AL' ? i.im : metricValue === 'CM' ? i.metric : i.imperial));
  const filteredNeckOptions: any[] = [];
  neckOptions.forEach((e) => {
    if (!filteredNeckOptions.includes(e)) {
      filteredNeckOptions.push(e);
    }
  });

  const bustOptions = (isMinor ? minorBustSize.concat(bustSize) : bustSize).map((i) =>
    metricValue === 'AL' ? i.im : metricValue === 'CM' ? i.metric : i.imperial,
  );
  const filteredBustOptions: any[] = [];
  bustOptions.forEach((e) => {
    if (!filteredBustOptions.includes(e)) {
      filteredBustOptions.push(e);
    }
  });

  // const array = [];
  // for (let index = 0.5; index < 26; index = index + 0.5) {
  //   array.push({ region: 'US', value: index.toString() });
  // }
  // console.log(array);

  const [isEthnicityDialogOpen, setIsEthnicityDialogOpen] = useState<boolean>(false);
  const handleCloseEthnicityDialog = () => setIsEthnicityDialogOpen(false);

  const [isTalentTypesDialogOpen, setIsTalentTypesDialogOpen] = useState<boolean>(false);
  const handleOpenTalentTypesDialog = () => setIsTalentTypesDialogOpen(true);
  const handleCloseTalentTypesDialog = () => setIsTalentTypesDialogOpen(false);

  const shoeOptions = maleShoeSize.map((i) =>
    metricValue === 'AL' ? i.im : metricValue === 'CM' ? i.metric : i.imperial,
  );
  const filteredShoeOptions: any[] = [];
  shoeOptions.forEach((e) => {
    if (!filteredShoeOptions.includes(e)) {
      filteredShoeOptions.push(e);
    }
  });

  const kidshoeOptions = kidsShoes.map((i) =>
    metricValue === 'AL' ? i.im : metricValue === 'CM' ? i.metric : i.imperial,
  );
  const filteredKidShoeOptions: any[] = [];
  kidshoeOptions.forEach((e) => {
    if (!filteredKidShoeOptions.includes(e)) {
      filteredKidShoeOptions.push(e);
    }
  });

  useEffect(() => {
    const genData = generalData?.data.attributes.general;

    if (genData !== null) {
      const gendata = {
        ethnic_appearance_other: genData?.ethnic_appearance_other || '',
        ethnic_appearance_primary: genData?.ethnic_appearance_primary || '',
        ethnic_appearance_secondary: genData?.ethnic_appearance_secondary || '',
        hair_colour: genData?.hair_colour || '',
        hair_length: genData?.hair_length || '',
        eye_colour: genData?.eye_colour || '',
        tattoo: genData?.tattoo || [],
        piercings: genData?.piercings || [],
        facial_hair: genData?.facial_hair || [],
        physical_attributes: genData?.physical_attributes || [],
        twin_triplet: genData?.twin_triplet || [],
      };

      setGeneralInfo((i) => ({
        ...i,
        ...gendata,
      }));
    }
  }, [generalData]);

  useEffect(() => {
    if (sData?.statistics) {
      if (sData?.statistics && sData?.statistics?.country) {
        if (sData?.statistics?.country === 'United States') setRegionValue('US');
        else if (sData?.statistics?.country === 'Australia') setRegionValue('AU');
        else if (sData?.statistics?.country === 'New Zealand') setRegionValue('NZ');
        else if (sData?.statistics?.country === 'Europe') setRegionValue('EU');
        else setRegionValue('UK');

        if (sData?.statistics?.metric_system === 'Imperial/Metric') setMetricValue('AL');
        else if (sData?.statistics?.metric_system === 'Imperial') setMetricValue('IN');
        else setMetricValue('CM');
      }
    }
  }, [sData?.statistics]);

  // const getMetricSystem = (e: any) => {
  //   form.setFieldValue('statistics.height', '');
  //   form.setFieldValue('statistics.weight', '');
  //   form.setFieldValue('statistics.waist', '');
  //   form.setFieldValue('statistics.inside_leg', '');
  //   form.setFieldValue('statistics.outside_leg', '');
  //   form.setFieldValue('statistics.chest_size', '');
  //   if (e === 'Imperial/Metric') setMetricValue('AL');
  //   else if (e === 'Imperial') setMetricValue('IN');
  //   else setMetricValue('CM');
  // };

  useEffect(() => {
    const e = form.values.statistics?.metric_system;
    if (e === 'Imperial/Metric') setMetricValue('AL');
    else if (e === 'Imperial') setMetricValue('IN');
    else setMetricValue('CM');
  }, [form.values.statistics?.metric_system]);

  function clearRegionDependentFields() {
    form.setFieldValue('statistics.coat_size', '');
    form.setFieldValue('statistics.dress_size', '');
    form.setFieldValue('statistics.shoe_size', '');
    form.setFieldValue('statistics.pants_size', '');
  }

  // useEffect(() => {
  //   if (JSON.stringify(form.initialValues) !== JSON.stringify(form.values)) {
  //     onDirty();
  //   } else {
  //     onPristine();
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [form, onDirty, onPristine]);

  const removeUnion = (index: number) => {
    const getUnionValues = form.values.unions || [];
    const filteredUnions = getUnionValues.filter((_, i) => i !== index);
    form.setFieldValue('unions', filteredUnions);
  };

  const addUnion = () => {
    const getUnionValues = form.values.unions || [];
    form.setFieldValue('unions', [
      ...getUnionValues,
      {
        name: unionToAdd.name,
        id_number: unionToAdd.id_number,
      },
    ]);

    setUnionToAdd({ name: '', id_number: '' });
  };

  const array: Array<any> = [];

  function roundToHalf(value: any) {
    const converted: any = parseFloat(value); // Make sure we have a number
    let decimal = converted - parseInt(converted, 10);
    decimal = Math.round(decimal * 10);
    if (decimal === 5) {
      return parseInt(converted, 10) + '½';
    }
    if (decimal < 1 || decimal > 5) {
      return Math.round(converted);
    } else {
      return parseInt(converted, 10) + '½';
    }
  }

  // Height maker
  // useEffect(() => {
  //   let foot = 3;
  //   let inches = 0;

  //   for (let i = foot; foot !== 9; inches++) {
  //     if (inches === 12) {
  //       foot += 1;
  //       inches = 0;
  //       const imperial = `${foot}'${
  //         inches % 1 ? inches.toString().substring(0, inches.toString().length - 2) + '½' : inches
  //       }''`;
  //       const metric = `${Math.round((foot * 12 + inches) * 2.54)}cm`;
  //       array.push({
  //         id: array.length,
  //         imperial,
  //         metric,
  //         im: `${imperial} / ${metric}`,
  //       });
  //     } else {
  //       // if (inches === 0.5) {
  //       //   const imperial = `${foot}'½''`;
  //       //   const metric = `${Math.round((foot * 12 + inches) * 2.54)}cm`;
  //       //   array.push({
  //       //     id: array.length,
  //       //     imperial,
  //       //     metric,
  //       //     im: `${imperial} / ${metric}`,
  //       //   });
  //       // } else {
  //       const imperial = `${foot}'${
  //         inches % 1 ? inches.toString().substring(0, inches.toString().length - 2) + '½' : inches
  //       }''`;
  //       const metric = `${Math.round((foot * 12 + inches) * 2.54)}cm`;
  //       array.push({
  //         id: array.length,
  //         imperial,
  //         metric,
  //         im: `${imperial} / ${metric}`,
  //       });
  //       // }

  //       // inches += 1;
  //     }
  //   }

  //   console.log('result', array);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  //Weight Maker
  // useEffect(() => {

  //   for (let i = 5; i !== 1000; i++) {
  //     //  const imperial = `${foot}'½''`;
  //     //  const metric = `${Math.round((foot * 12 + inches) * 2.54)}cm`;
  //     const imperial = i + ' lbs';
  //     const metric = roundToHalf(i / 2.20462) + ' kg';
  //     array.push({
  //       // or: i / 2.20462,
  //       id: array.length,
  //       imperial,
  //       metric,
  //       im: `${imperial} / ${metric}`,
  //     });
  //   }

  //   console.log('result', array);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  // Waist maker
  // useEffect(() => {
  //   for (let i = 10; i !== 100; i++) {
  //     const imperial = `${i}''`;
  //     // const metric = roundToHalf(i * 2.54) + ' cm';
  //     const metric = Math.round(i * 2.54) + ' cm';
  //     array.push({
  //       // or: i * 2.54,
  //       id: array.length,
  //       imperial,
  //       metric,
  //       im: `${imperial} / ${metric}`,
  //     });
  //   }

  //   console.log('result', array);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  // Inseam maker
  // useEffect(() => {
  //   for (let i = 20; i !== 41; i++) {
  //     const imperial = `${i}''`;
  //     // const metric = roundToHalf(i * 2.54) + ' cm';
  //     const metric = Math.round(i * 2.54) + ' cm';
  //     array.push({
  //       // or: i * 2.54,
  //       id: array.length,
  //       imperial,
  //       metric,
  //       im: `${imperial} / ${metric}`,
  //     });
  //   }
  // })

  //   console.log('result', array);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  // Shoe Size Maker
  // useEffect(() => {
  //   for (let i = 3; i !== 26; i = i + 0.5) {
  //     const imperial = `${i}`;
  //     const metric = `${i}`;
  //     array.push({
  //       // or: i * 2.54,
  //       id: array.length,
  //       imperial,
  //       metric,
  //       im: `${imperial}`,
  //     });
  //   }

  //   console.log('result', array);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  // Hat Size Maker
  // useEffect(() => {
  //   for (let i = 20; i !== 29; i = i + 0.25) {
  //     const inArr = i.toString().split('.');
  //     const imperial =
  //       `${inArr[0]}` + `${inArr[1] === '5' ? '½' : inArr[1] === '25' ? '¼' : inArr[1] === '75' ? '¾' : ''}''`;
  //     // const metric = `${roundToHalf(i * 2.54)} cm`;
  //     const metric = `${Math.round(i * 2.54)} cm`;
  //     array.push({
  //       // or: i * 2.54,
  //       id: array.length,
  //       imperial,
  //       metric,
  //       im: `${imperial} / ${metric}`,
  //     });
  //   }

  //   console.log('result', array);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  // Glove Size Maker
  // useEffect(() => {
  //   for (let i = 6; i !== 17; i = i + 0.5) {
  //     const imperial = `${i}`;
  //     const metric = `${i}`;
  //     array.push({
  //       // or: i * 2.54,
  //       id: array.length,
  //       imperial,
  //       metric,
  //       im: `${imperial}`,
  //     });
  //   }

  //   console.log('result', array);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  // Chest Size maker
  // useEffect(() => {
  //   for (let i = 20; i !== 76; i++) {
  //     const inArr = i.toString().split('.');
  //     const imperial = `${inArr[0]}` + `${inArr[1] === '5' ? '½' : ''}''`;
  //     // const metric = roundToHalf(i * 2.54) + ' cm';
  //     const metric = Math.round(i * 2.54) + ' cm';
  //     array.push({
  //       // or: i * 2.54,
  //       id: array.length,
  //       imperial,
  //       metric,
  //       im: `${imperial} / ${metric}`,
  //     });
  //   }

  //   console.log('result', array);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  // Neck Size maker
  useEffect(() => {
    for (let i = 15; i !== 41; i = i + 0.5) {
      const inArr = i.toString().split('.');
      const imperial = `${inArr[0]}` + `${inArr[1] === '5' ? '½' : ''}''`;
      // const metric = roundToHalf(i * 2.54) + ' cm';
      const metric = Math.round(i * 2.54) + ' cm';
      array.push({
        // or: i * 2.54,
        id: array.length,
        imperial,
        metric,
        im: `${imperial} / ${metric}`,
      });
    }
  }, []);

  //Sleeve Size Maker
  // useEffect(() => {
  //   for (let i = 10; i !== 51; i = i + 0.5) {
  //     const inArr = i.toString().split('.');
  //     const imperial = `${inArr[0]}` + `${inArr[1] === '5' ? '½' : ''}''`;
  //     // const metric = roundToHalf(i * 2.54) + ' cm';
  //     const metric = Math.round(i * 2.54) + ' cm';
  //     array.push({
  //       // or: i * 2.54,
  //       id: array.length,
  //       imperial,
  //       metric,
  //       im: `${imperial} / ${metric}`,
  //     });
  //   }

  //   console.log('result', array);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  // Sleeve Size Maker
  // useEffect(() => {
  //   for (let i = 10; i !== 51; i = i + 0.5) {
  //     const inArr = i.toString().split('.');
  //     const imperial = `${inArr[0]}` + `${inArr[1] === '5' ? '½' : ''}''`;
  //     const metric = roundToHalf(i * 2.54) + ' cm';
  //     array.push({
  //       // or: i * 2.54,
  //       id: array.length,
  //       imperial,
  //       metric,
  //       im: `${imperial} / ${metric}`,
  //     });
  //   }

  //   console.log('result', array);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  //By 2 Maker
  // useEffect(() => {
  //   for (let i = 30; i !== 60; i = i + 2) {
  //     array.push({
  //       key: `${i}`,
  //       value: `${i}`,
  //     });
  //   }

  //   console.log('result', array);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  // Hips Size maker
  // useEffect(() => {
  //   for (let i = 10; i !== 101; i++) {
  //     const inArr = i.toString().split('.');
  //     const imperial = `${inArr[0]}` + `${inArr[1] === '5' ? '½' : ''}''`;
  //     // const metric = roundToHalf(i * 2.54) + ' cm';
  //     const metric = Math.round(i * 2.54) + ' cm';
  //     array.push({
  //       // or: i * 2.54,
  //       id: array.length,
  //       imperial,
  //       metric,
  //       im: `${imperial} / ${metric}`,
  //     });
  //   }

  //   console.log('result', array);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  // Bust Size maker
  // useEffect(() => {
  //   for (let i = 10; i !== 76; i++) {
  //     const inArr = i.toString().split('.');
  //     const imperial = `${inArr[0]}` + `${inArr[1] === '5' ? '½' : ''}''`;
  //     // const metric = roundToHalf(i * 2.54) + ' cm';
  //     const metric = Math.round(i * 2.54) + ' cm';

  //     array.push({
  //       // or: i * 2.54,
  //       id: array.length,
  //       imperial,
  //       metric,
  //       im: `${imperial} / ${metric}`,
  //     });
  //   }

  //   console.log('result', array);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  // Kids Shoe Size Maker
  // useEffect(() => {
  //   for (let i = 0; i !== 12.5; i = i + 0.5) {
  //     const imperial = `${i}`;
  //     const metric = `${i}`;
  //     array.push({
  //       // or: i * 2.54,
  //       id: array.length,
  //       imperial,
  //       metric,
  //       im: `${imperial}`,
  //     });
  //   }

  //   console.log('result', array);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  // Length maker
  // useEffect(() => {
  //   for (let i = 0; i !== 16; i = i + 0.5) {
  //     const imperial = `${i}`;
  //     const metric = `${i}`;
  //     array.push({
  //       // or: i * 2.54,
  //       id: array.length,
  //       imperial,
  //       metric,
  //       im: `${imperial}`,
  //     });
  //   }

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  const usButtonValidation = () => {
    const { weight, height, shoe_size, kid_shoe_size, length, kidsClothing } = form.values.statistics || {};

    if (form.values.adult_minor === 'baby') {
      return !length || !kid_shoe_size || !kidsClothing;
    } else if (form.values.adult_minor === 'minor') {
      return !height || !weight || !kid_shoe_size;
    } else {
      return !height || !weight || !shoe_size;
    }
  };

  const buttonValidation = () => {
    const {
      height,
      dress_size,
      bra_size,
      bust_size,
      waist,
      hip_size,
      shoe_size,
      kid_shoe_size,
      kidsClothing,
      suit_size,
      chest_size,
      weight,
      coat_size,
      cup_size,
      length,
    } = form.values.statistics || {};
    const { gender, country, adult_minor, unions } = form.values;
    if (!gender) return true;
    if (!country) return true;

    // if (unions?.length && unions[0]?.name !== 'NON UNION') {
    //   return unions[0]?.id_number === '';
    // }

    //validation based on required fields

    if (country === 'United States') return usButtonValidation();
    return (
      !height ||
      (adult_minor === 'minor' || adult_minor === 'baby'
        ? adult_minor === 'minor'
          ? !kid_shoe_size
          : !kid_shoe_size || !length
        : !shoe_size)
    );

    // const usReq = country === 'United States' ? !weight : false;
    // const usCup = country === 'United States' ? !cup_size : false;
    // const usSuitReq = country === 'United States' ? !coat_size : false;
    // const auReq = country === 'Australia' ? !suit_size : false;
    // const kidsCommon = !kid_shoe_size || !kidsClothing || usReq;

    // if (adult_minor === 'baby') {
    //   return !length || !weight || !kidsClothing || !kid_shoe_size;
    // }
    // if (gender === 'Female' || gender === 'Trans Woman') {
    //   const femaleCommon = !height || !dress_size || !bust_size || !waist || usReq;
    //   if (form.values.adult_minor === 'minor') {
    //     return femaleCommon || kidsCommon;
    //   } else {
    //     return femaleCommon || !shoe_size || !hip_size || usCup;
    //   }
    // } else if (gender === 'Male' || gender === 'Trans Man') {
    //   const maleCommon = !height || !chest_size || !waist || usReq || usSuitReq || auReq;

    //   if (form.values.adult_minor === 'minor') {
    //     return !height || !chest_size || !waist || kidsCommon;
    //   } else {
    //     return maleCommon || !shoe_size;
    //   }
    // } else if (gender === 'Non-Binary' || gender === 'Other') {
    //   return (
    //     !height ||
    //     !cup_size ||
    //     !chest_size ||
    //     !bust_size ||
    //     !waist ||
    //     !hip_size ||
    //     !dress_size ||
    //     auReq ||
    //     !shoe_size ||
    //     usReq
    //   );
    // }
  };

  const handleAutocompleteChange = (field_key: string, val: string | null) => {
    setGeneralInfo((i) => ({ ...i, [field_key]: val }));
  };

  const { gender } = form.values || {};
  const isRequired = (field: string) => requiredFields?.includes(field);

  return (
    <MainCont style={{ padding: checkinSelfTapes ? 0 : 25 }}>
      {isOpportunities || compCardAdd ? (
        <GeneralOnSizeCard
          compCardAdd={compCardAdd}
          compCardRemove={compCardRemove}
          handleAutocompleteChange={handleAutocompleteChange}
          generalInfo={generalInfo}
          setmeInfo={setmeInfo}
          birth={birth}
          setBirth={setBirth}
          val={val}
          setVal={setVal}
        />
      ) : (
        <React.Fragment />
      )}
      {!checkinSelfTapes ? (
        <CustomTypography fontSize={25}>Size Card</CustomTypography>
      ) : (
        <CustomTypography fontSize={25}>Size Card Information</CustomTypography>
      )}
      <Heading>
        <CustomTypography fontSize={16}>Settings</CustomTypography>
        {checkinSelfTapes ? (
          <IconButton
            onClick={() => setCollapsibles({ ...collapsibles, settings: !collapsibles.settings })}
            style={{ marginLeft: 'auto', padding: 0, width: 30, height: 30, color: COLORS.PRIMARY }}
          >
            <BsChevronDoubleDown
              style={{
                transform: collapsibles.settings ? 'rotate(180deg)' : 'rotate(0deg)',
                transition: 'transform 0.2s ease-in-out',
              }}
            />
          </IconButton>
        ) : null}
      </Heading>
      <Collapse in={collapsibles.settings} timeout="auto" unmountOnExit>
        <ThreeColumn isModal={+Boolean(isOpportunities)}>
          {!checkinSelfTapes && (
            <>
              <div>
                <InputLabel id="labelAgeType">Select Adult/Minor or Baby Sizes</InputLabel>

                <Select
                  variant="outlined"
                  fullWidth
                  data={age}
                  className={classes.select}
                  value={form.values.adult_minor || form.values?.statistics?.adult_minor}
                  // IconComponent={SelectArrowDownIcon}
                  name="statistics.adult_minor"
                  onChange={(e: any) => {
                    if ((e.target.value === 'minor' || e.target.value === 'baby') && form.values.gender !== 'Male') {
                      if (form.values.gender !== 'Female') form.setFieldValue('gender', 'Male');
                    }
                    form.handleChange(e);
                    // modifying adult_minor value to change sizes. Will be deleted on submit
                    form.setFieldValue('adult_minor', e.target.value);
                  }}
                  placeHolder="Select"
                />
              </div>
              <div>
                <InputLabel id="labelSizeUnit">Imperial/Metric</InputLabel>

                <Select
                  variant="outlined"
                  fullWidth
                  data={metric}
                  value={form.values.statistics?.metric_system}
                  // IconComponent={SelectArrowDownIcon}
                  className={classes.select}
                  name="statistics.metric_system"
                  onChange={form.handleChange}
                  placeHolder="Select"
                />
              </div>
            </>
          )}
          <div>
            <InputLabel id="labelCountry">Region</InputLabel>
            <Autocomplete
              id="SC-Region"
              onChange={(e, newValue) => {
                form.setFieldValue('country', newValue);
                clearRegionDependentFields();
                if (newValue === 'United States') setRegionValue('US');
                else if (newValue === 'Australia') setRegionValue('AU');
                else if (newValue === 'New Zealand') setRegionValue('NZ');
                else if (newValue === 'Europe') setRegionValue('EU');
                else setRegionValue('UK');
              }}
              value={form.values.country}
              options={region.map((i) => i.value)}
              getOptionSelected={(option, value) => option === value}
              fullWidth
              classes={{
                option: classes.option,
              }}
              renderInput={(params) => (
                <TextInput
                  {...params}
                  placeholder={'Select Region'}
                  errorMessage={!form.values.country ? 'Region is required' : ''}
                  InputProps={{
                    ...params.InputProps,
                    classes: {
                      root: classes.textInputStyle,
                    },
                  }}
                />
              )}
            />
          </div>
          <div>
            <InputLabel id="representationStatus">Gender</InputLabel>
            <Select
              variant="outlined"
              fullWidth
              className={classes.select}
              data={
                form.values.adult_minor === 'minor' || form.values.adult_minor === 'baby'
                  ? Gender.filter((g) => g.key === 'Female' || g.key === 'Male')
                  : Gender
              }
              value={form.values.gender}
              // IconComponent={SelectArrowDownIcon}
              name="gender"
              onChange={(e) => {
                if (form.errors.gender && !form.touched.gender) {
                  form.setFieldTouched('gender');
                  form.validateField('gender');
                }
                form.handleChange(e);
              }}
              placeHolder="Select Gender"
              errorMessage={getErrorMessage(form.values.gender === '', 'Gender is required')}
            />
          </div>
          {form.values.adult_minor !== 'baby' ? (
            <div>
              <InputLabel id="representationStatus">Identity</InputLabel>
              <Select
                variant="outlined"
                className={classes.select}
                fullWidth
                data={Pronouns}
                onBlur={form.handleBlur}
                value={form.values.identifies_as}
                // IconComponent={SelectArrowDownIcon}
                name="identifies_as"
                onChange={form.handleChange}
                placeHolder="Identifies As"
              />
            </div>
          ) : (
            <React.Fragment />
          )}
        </ThreeColumn>
      </Collapse>
      {checkinSelfTapes && form.values.country?.toLowerCase() === 'united states' ? (
        <>
          <Heading>
            <CustomTypography fontSize={16}>Union Status</CustomTypography>
            <IconButton
              onClick={() => setCollapsibles({ ...collapsibles, unions: !collapsibles.unions })}
              style={{ marginLeft: 'auto', padding: 0, width: 30, height: 30, color: COLORS.PRIMARY }}
            >
              <BsChevronDoubleDown
                style={{
                  transform: collapsibles.unions ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: 'transform 0.2s ease-in-out',
                }}
              />
            </IconButton>
          </Heading>
          <Collapse in={collapsibles.unions} timeout="auto" unmountOnExit>
            <ThreeColumn isModal={+Boolean(isOpportunities)}>
              <TwoColumn6Grid item>
                <Grid item lg={12} md={12} xs={12}>
                  <Select
                    variant="outlined"
                    // data={usaUnion}
                    data={unionList}
                    className={classes.select}
                    // IconComponent={SelectArrowDownIcon}
                    fullWidth
                    placeHolder="Select a Union"
                    value={form.values.unions?.length ? form.values.unions[0]?.name : 'NON UNION'}
                    onChange={form.handleChange}
                    name="unions[0].name"
                  />
                </Grid>

                {form.values.unions?.length && form.values.unions[0]?.name !== 'NON UNION' ? (
                  <Grid item lg={12} md={12} xs={12}>
                    <TextInput
                      className={classes.UnionInput}
                      placeholder="Enter SAG ID"
                      name={'unions[0].id_number'}
                      value={form.values.unions?.length ? form.values.unions[0]?.id_number : ''}
                      onChange={form.handleChange}
                      errorMessage={isSagNumberRequired ? 'ID Number is required' : ''}
                    />
                  </Grid>
                ) : (
                  <React.Fragment />
                )}
              </TwoColumn6Grid>
            </ThreeColumn>
          </Collapse>
        </>
      ) : (
        <></>
      )}
      <Heading>
        Sizes
        {isMinor ? (
          <span style={{ marginLeft: 'auto', color: COLORS.MAIN_GRAY, fontStyle: 'italic' }}>
            Use the size dropdown above if you prefer to use Adult Sizes
          </span>
        ) : (
          <React.Fragment />
        )}
      </Heading>
      {form.values.adult_minor === 'baby' ? (
        <ThreeColumn isModal={+Boolean(isOpportunities)}>
          <div>
            <CompCardButton
              onClick={compCardAdd}
              attributes={{
                label: 'Weight',
                key: 'weight',
              }}
              hasValue={form.values.statistics?.weight !== '' && form.values.statistics?.weight !== null}
            />
            <Autocomplete
              id="sizeCardWeight"
              filterOptions={filterOptions}
              onChange={(e, newValue, reason) => {
                if (compCardRemove && reason === 'clear') {
                  compCardRemove({ key: 'weight' });
                }
                form.setFieldValue('statistics.weight', newValue);
              }}
              value={form.values.statistics?.weight}
              options={newweight.map((i) =>
                metricValue === 'AL' ? i.im : metricValue === 'CM' ? i.metric : i.imperial,
              )}
              getOptionSelected={(option, value) => option === value}
              fullWidth
              classes={{
                option: classes.option,
              }}
              renderInput={(params) => (
                <TextInput
                  {...params}
                  placeholder={'Select Weight'}
                  InputProps={{
                    ...params.InputProps,
                    classes: {
                      root: classes.textInputStyle,
                    },
                  }}
                  errorMessage={isRequired('weight') && !form.values.statistics?.weight ? 'Weight is required' : ''}
                />
              )}
            />
          </div>
          <Babies
            compCardAdd={compCardAdd}
            compCardRemove={compCardRemove}
            form={form}
            filterOptions={filterOptions}
            kidsLengthOptions={filteredLengthOptions}
            kidClothing={kidClothing}
            infants={infants}
            filteredKidShoeOptions={kidshoeOptions}
            requiredFields={requiredFields}
          />
        </ThreeColumn>
      ) : (
        <ThreeColumn isModal={+Boolean(isOpportunities)}>
          <div>
            <CompCardButton
              onClick={compCardAdd}
              attributes={{
                label: 'Height',
                key: 'height',
              }}
              hasValue={form.values.statistics?.height !== '' && form.values.statistics?.height !== null}
            />
            <Autocomplete
              id="sizeCardHeight"
              filterOptions={filterOptions}
              onChange={(e, newValue, reason) => {
                if (compCardRemove && reason === 'clear') {
                  compCardRemove({ key: 'height' });
                }
                form.setFieldValue('statistics.height', newValue);
              }}
              value={form.values.statistics?.height}
              options={filteredHeightOptions}
              getOptionSelected={(option, value) => option === value}
              fullWidth
              classes={{
                option: classes.option,
              }}
              renderInput={(params) => (
                <TextInput
                  {...params}
                  InputProps={{
                    ...params.InputProps,
                    classes: {
                      root: classes.textInputStyle,
                    },
                  }}
                  placeholder={'Select Height'}
                  errorMessage={form.values.statistics?.height ? '' : 'Height is required'}
                />
              )}
            />
          </div>
          {requiredFields?.includes('weight') && (
            <div>
              <CompCardButton
                onClick={compCardAdd}
                attributes={{
                  label: 'Weight',
                  key: 'weight',
                }}
                hasValue={form.values.statistics?.weight !== '' && form.values.statistics?.weight !== null}
              />
              <Autocomplete
                id="sizeCardWeight"
                filterOptions={filterOptions}
                onChange={(e, newValue, reason) => {
                  if (compCardRemove && reason === 'clear') {
                    compCardRemove({ key: 'weight' });
                  }
                  form.setFieldValue('statistics.weight', newValue);
                }}
                value={form.values.statistics?.weight}
                options={newweight.map((i) =>
                  metricValue === 'AL' ? i.im : metricValue === 'CM' ? i.metric : i.imperial,
                )}
                getOptionSelected={(option, value) => option === value}
                fullWidth
                classes={{
                  option: classes.option,
                }}
                renderInput={(params) => (
                  <TextInput
                    {...params}
                    placeholder={'Select Weight'}
                    InputProps={{
                      ...params.InputProps,
                      classes: {
                        root: classes.textInputStyle,
                      },
                    }}
                    errorMessage={
                      !form.values.statistics?.weight && form.values.country !== 'Australia' ? 'Weight is required' : ''
                    }
                  />
                )}
              />
            </div>
          )}
          {checkinSelfTapes &&
            (form.values.adult_minor === 'minor' ? (
              <div>
                <CompCardButton
                  onClick={compCardAdd}
                  attributes={{
                    label: 'Kids Shoe Size',
                    key: 'kid_shoe_size',
                  }}
                  hasValue={
                    form.values.statistics?.kid_shoe_size !== '' && form.values.statistics?.kid_shoe_size !== null
                  }
                />
                <Autocomplete
                  id="SC-kidsShoeSize"
                  filterOptions={filterOptions}
                  onChange={(e, newValue, reason) => {
                    if (compCardRemove && reason === 'clear') {
                      compCardRemove({ key: 'kid_shoe_size' });
                    }
                    form.setFieldValue('statistics.kid_shoe_size', newValue);
                  }}
                  value={form.values.statistics?.kid_shoe_size}
                  options={filteredKidShoeOptions}
                  getOptionSelected={(option, value) => option === value}
                  fullWidth
                  classes={{
                    option: classes.option,
                  }}
                  renderInput={(params) => (
                    <TextInput
                      {...params}
                      InputProps={{
                        ...params.InputProps,
                        classes: {
                          root: classes.textInputStyle,
                        },
                      }}
                      placeholder={'Select Shoe Size'}
                      errorMessage={!form.values.statistics?.kid_shoe_size ? 'Shoe size is required' : ''}
                    />
                  )}
                />
              </div>
            ) : (
              <div>
                <CompCardButton
                  onClick={compCardAdd}
                  attributes={{
                    label: 'Shoe Size',
                    key: 'shoe_size',
                  }}
                  hasValue={form.values.statistics?.shoe_size !== '' && form.values.statistics?.shoe_size !== null}
                />
                <Autocomplete
                  id="SC-shoeSize"
                  filterOptions={filterOptions}
                  onChange={(e, newValue, reason) => {
                    if (compCardRemove && reason === 'clear') {
                      compCardRemove({ key: 'shoe_size' });
                    }
                    form.setFieldValue('statistics.shoe_size', newValue);
                  }}
                  value={form.values.statistics?.shoe_size}
                  options={filteredShoeOptions}
                  getOptionSelected={(option, value) => option === value}
                  fullWidth
                  classes={{
                    option: classes.option,
                  }}
                  renderInput={(params) => (
                    <TextInput
                      {...params}
                      InputProps={{
                        ...params.InputProps,
                        classes: {
                          root: classes.textInputStyle,
                        },
                      }}
                      placeholder={'Select Shoe Size'}
                      errorMessage={!form.values.statistics?.shoe_size ? 'Shoe size is required' : ''}
                    />
                  )}
                />
              </div>
            ))}

          {gender === 'Male' || gender === 'Trans Man' ? (
            <Male
              showNonRequiredFields={nonRequiredFields}
              requiredOnly={requiredOnly}
              requiredFields={requiredFields}
              compCardAdd={compCardAdd}
              compCardRemove={compCardRemove}
              form={form}
              filterOptions={filterOptions}
              filteredChestOptions={filteredChestOptions}
              filteredWaistOptions={filteredWaistOptions}
            />
          ) : gender === 'Female' || gender === 'Trans Woman' ? (
            <Female
              showNonRequiredFields={nonRequiredFields}
              requiredOnly={requiredOnly}
              requiredFields={requiredFields}
              compCardAdd={compCardAdd}
              compCardRemove={compCardRemove}
              form={form}
              filteredBustOptions={filteredBustOptions}
              filterOptions={filterOptions}
              filteredWaistOptions={filteredWaistOptions}
              metricValue={metricValue || ''}
            />
          ) : (
            <NonBinary
              showNonRequiredFields={nonRequiredFields}
              requiredOnly={requiredOnly}
              requiredFields={requiredFields}
              compCardAdd={compCardAdd}
              compCardRemove={compCardRemove}
              form={form}
              filterOptions={filterOptions}
              filteredChestOptions={filteredChestOptions}
              filteredWaistOptions={filteredWaistOptions}
              filteredShoeOptions={filteredShoeOptions}
              filteredInseamOptions={filteredInseamOptions}
              filteredNeckOptions={filteredNeckOptions}
              sleeveOption={sleeveOption}
              filteredHatOptions={filteredHatOptions}
              filteredGloveOptions={filteredGloveOptions}
              filteredBustOptions={filteredBustOptions}
              metricValue={metricValue || ''}
            />
          )}
          <Common
            requiredOnly={requiredOnly}
            requiredFields={requiredFields}
            compCardAdd={compCardAdd}
            compCardRemove={compCardRemove}
            form={form}
            filterOptions={filterOptions}
            filteredShoeOptions={filteredShoeOptions}
            filteredInseamOptions={filteredInseamOptions}
            filteredNeckOptions={filteredNeckOptions}
            sleeveOption={sleeveOption}
            filteredHatOptions={filteredHatOptions}
            filteredGloveOptions={filteredGloveOptions}
            filteredBustOptions={filteredBustOptions}
            filteredKidShoeOptions={filteredKidShoeOptions}
          />
          {!checkinSelfTapes &&
            (form.values.adult_minor === 'minor' ? (
              <div>
                <CompCardButton
                  onClick={compCardAdd}
                  attributes={{
                    label: 'Kids Shoe Size',
                    key: 'kid_shoe_size',
                  }}
                  hasValue={
                    form.values.statistics?.kid_shoe_size !== '' && form.values.statistics?.kid_shoe_size !== null
                  }
                />
                <Autocomplete
                  id="SC-kidsShoeSize"
                  filterOptions={filterOptions}
                  onChange={(e, newValue, reason) => {
                    if (compCardRemove && reason === 'clear') {
                      compCardRemove({ key: 'kid_shoe_size' });
                    }
                    form.setFieldValue('statistics.kid_shoe_size', newValue);
                  }}
                  value={form.values.statistics?.kid_shoe_size}
                  options={filteredKidShoeOptions}
                  getOptionSelected={(option, value) => option === value}
                  fullWidth
                  classes={{
                    option: classes.option,
                  }}
                  renderInput={(params) => (
                    <TextInput
                      {...params}
                      InputProps={{
                        ...params.InputProps,
                        classes: {
                          root: classes.textInputStyle,
                        },
                      }}
                      placeholder={'Select Shoe Size'}
                      errorMessage={!form.values.statistics?.kid_shoe_size ? 'Shoe size is required' : ''}
                    />
                  )}
                />
              </div>
            ) : (
              <div>
                <CompCardButton
                  onClick={compCardAdd}
                  attributes={{
                    label: 'Shoe Size',
                    key: 'shoe_size',
                  }}
                  hasValue={form.values.statistics?.shoe_size !== '' && form.values.statistics?.shoe_size !== null}
                />
                <Autocomplete
                  id="SC-shoeSize"
                  filterOptions={filterOptions}
                  onChange={(e, newValue, reason) => {
                    if (compCardRemove && reason === 'clear') {
                      compCardRemove({ key: 'shoe_size' });
                    }
                    form.setFieldValue('statistics.shoe_size', newValue);
                  }}
                  value={form.values.statistics?.shoe_size}
                  options={filteredShoeOptions}
                  getOptionSelected={(option, value) => option === value}
                  fullWidth
                  classes={{
                    option: classes.option,
                  }}
                  renderInput={(params) => (
                    <TextInput
                      {...params}
                      InputProps={{
                        ...params.InputProps,
                        classes: {
                          root: classes.textInputStyle,
                        },
                      }}
                      placeholder={'Select Shoe Size'}
                      errorMessage={!form.values.statistics?.shoe_size ? 'Shoe size is required' : ''}
                    />
                  )}
                />
              </div>
            ))}
        </ThreeColumn>
      )}

      {/* only if not baby and not on checkinSelfTapes */}
      {form.values.adult_minor !== 'baby' && !checkinSelfTapes && (
        <NonRequired
          newweight={newweight}
          requiredOnly={requiredOnly}
          requiredFields={requiredFields}
          compCardAdd={compCardAdd}
          compCardRemove={compCardRemove}
          form={form}
          filterOptions={filterOptions}
          filteredChestOptions={filteredChestOptions}
          filteredWaistOptions={filteredWaistOptions}
          filteredShoeOptions={filteredShoeOptions}
          filteredInseamOptions={filteredInseamOptions}
          filteredNeckOptions={filteredNeckOptions}
          sleeveOption={sleeveOption}
          filteredHatOptions={filteredHatOptions}
          filteredGloveOptions={filteredGloveOptions}
          filteredBustOptions={filteredBustOptions}
          setRequiredOnly={setRequiredOnly}
          filteredKidShoeOptions={filteredKidShoeOptions}
          gender={gender}
          metricValue={metricValue || ''}
        />
      )}

      <FlexContainer $gap={20}>
        <SaveButton
          variant="contained"
          color="primary"
          fullWidth
          onClick={() => {
            form.handleSubmit();
          }}
          disabled={
            (isLoading || checkinSelfTapes || compCardAdd ? buttonValidation() : buttonValidation() || !form.dirty) ||
            disableButton ||
            isSagNumberRequired
          }
        >
          {isLoading ? (
            <CircularProgress style={{ color: COLORS.WHITE }} size={25} />
          ) : checkinSelfTapes ? (
            isOpportunities ? (
              'Save & Submit'
            ) : (
              'Save & Next'
            )
          ) : (
            'Save Changes'
          )}
        </SaveButton>
        {!checkinSelfTapes && <NotificationText show={show} setShow={setShow} />}
      </FlexContainer>
      <EthnicityDialog
        key={form.values.statistics?.ethnicity?.length}
        open={isEthnicityDialogOpen}
        onClose={handleCloseEthnicityDialog}
        selectedChips={form.values.statistics?.ethnicity}
        setSelectedChips={(field: any, value: any) => form.setFieldValue(field, value)}
      />
      <TalentTypesDialog
        key={form.values.statistics?.other_talent_types?.length}
        open={isTalentTypesDialogOpen}
        onClose={handleCloseTalentTypesDialog}
        selectedChips={form.values.statistics?.other_talent_types}
        setSelectedChips={(field: any, value: any) => form.setFieldValue(field, value)}
      />
      <Backdrop isLoading={isSizeCardLocading ? isSizeCardLocading : isUpdateLoading ? isUpdateLoading : false} />
      {routerPrompt}
    </MainCont>
  );
};

export default SizeCard;
